import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 21l-8 -4.5v-9l8 -4.5l8 4.5v4.5","key":"svg-0"}],["path",{"d":"M12 12l8 -4.5","key":"svg-1"}],["path",{"d":"M12 12v9","key":"svg-2"}],["path",{"d":"M12 12l-8 -4.5","key":"svg-3"}],["path",{"d":"M15 18h7","key":"svg-4"}],["path",{"d":"M19 15l3 3l-3 3","key":"svg-5"}]]

const IconPackageExport = createReactComponent('outline', 'package-export', 'PackageExport', __iconNode);

export default IconPackageExport;